// extracted by mini-css-extract-plugin
export default {"root":"It2cGVZLUj"};